import { render, staticRenderFns } from "./BenchmarkBarGroup.vue?vue&type=template&id=3d0b8902&scoped=true&"
import script from "./BenchmarkBarGroup.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkBarGroup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BenchmarkBarGroup.vue?vue&type=style&index=0&id=3d0b8902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b8902",
  null
  
)

export default component.exports